import { FaRegCircle } from "react-icons/fa";
import { FaRegCircleCheck } from "react-icons/fa6";

const RadioButton = ({
  label,
  options,
  selected,
  onChange,
  isRequired = false,
  inputClassName,
  name,
  isBoolean,
}) => {
  return (
    <div>
      <label className="block text-base font-medium text-gray-700 mb-2">
        {label}
        {isRequired && <span className="text-red-500 ml-1 font-bold">*</span>}
      </label>

      <div className={`flex space-x-6 ${inputClassName} `}>
        {options?.map((option, index) => (
          <label
            key={index}
            className="inline-flex items-center cursor-pointer"
          >
            <input
              type="radio"
              name={name ? name : "referenceId"}
              value={
                isBoolean ? option?.id : option?.id ?? option?.toLowerCase()
              }
              checked={
                isBoolean
                  ? selected == option?.id
                  : option?.id
                  ? selected === option?.id?.toLowerCase()
                  : selected === option?.toLowerCase()
              }
              onChange={onChange}
              className="hidden"
            />
            <span className="flex items-center justify-center w-5 h-5 border rounded-full mr-2">
              {isBoolean ? (
                selected === option?.id ? (
                  <FaRegCircleCheck className="w-5 h-5 text-[#2BACE2] fill-[#2BACE2]" />
                ) : (
                  <FaRegCircle className="w-5 h-5 text-gray-300" />
                )
              ) : (
                  option?.id
                    ? selected === option?.id
                    : selected === option?.toLowerCase()
                ) ? (
                <FaRegCircleCheck className="w-5 h-5 text-[#2BACE2] fill-[#2BACE2]" />
              ) : (
                <FaRegCircle className="w-5 h-5 text-gray-300" />
              )}
            </span>
            <span className="text-gray-900">
              {isBoolean ? option?.label : option?.id ? option?.label : option}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default RadioButton;
